import { samplesConfigObj } from '@/components/Glossary/Sections/SampleTypes/SamplesConfig';
import { preventNumberScroll } from '@/helpers';
import { _notNil } from '@/littledash';
import { ErrorMessage } from '@hookform/error-message';
import type { FC } from 'react';
//@ts-expect-error - old hook form - replace with `react-hook-form@latest`
import { useFormContext } from 'react-hook-form';

interface DetailFieldProps {
  detailKey: string;
  value?: string;
  unit?: string;
  fieldIndex: number;
  unitDisabled?: boolean;
}

export const DetailField: FC<DetailFieldProps> = ({ detailKey, value, unit, fieldIndex, unitDisabled }) => {
  const { register, errors } = useFormContext();
  return (
    <div className="w-50 pa2" data-test-component="DetailField" data-test-element="container" data-test-key={detailKey}>
      <label>{samplesConfigObj?.[detailKey]?.title}</label>
      <div className="flex">
        <input type="hidden" value={detailKey} name={`details[${fieldIndex}].key`} ref={register()} />
        <input
          type="number"
          onWheel={preventNumberScroll}
          className="w-100 mr2"
          data-test-element="number-input"
          step="any"
          style={{ marginBottom: 0 }}
          name={`details[${fieldIndex}].value`}
          ref={register({
            valueAsNumber: true,
            pattern: {
              value: /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/,
              message: 'Must be a valid number',
            },
          })}
          defaultValue={value}
        />
        {_notNil(samplesConfigObj?.[detailKey]?.units) && (
          <>
            {unitDisabled === true && (
              <input type="hidden" value={unit} name={`details[${fieldIndex}].unit`} ref={register()} />
            )}
            <select
              className="w3"
              name={unitDisabled === true ? undefined : `details[${fieldIndex}].unit`}
              data-test-element="unit-select"
              ref={unitDisabled === true ? undefined : register()}
              style={{ marginBottom: 0 }}
              defaultValue={unit}
              disabled={unitDisabled === true}
              data-tooltip-id="global-tooltip-id"
              data-tooltip-content={
                unitDisabled === true ? 'Units cannot be changed for samples linked to a sample plan' : undefined
              }
            >
              {samplesConfigObj[detailKey].units.map((configUnit: string) => (
                <option key={`${detailKey}_${configUnit}`} value={configUnit}>
                  {configUnit}
                </option>
              ))}
            </select>
          </>
        )}
      </div>
      <ErrorMessage
        errors={errors}
        name={`details[${fieldIndex}].value`}
        render={({ message }) => <p className="f6 red db pt2">{message}</p>}
      />
    </div>
  );
};
